import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { TextInput } from 'SRC/ui/FormElements'
import config from 'SRC/config/config.json'

export const ConfirmPassword = () => {
  const { t } = useTranslation('common')

  const confirmPasswordField = {
    id: 'confirmPassword',
    name: 'confirmPassword',
    type: 'password',
    label: t('Ponovite novu šifru'),
    isRequired: true
  }

  return  <TextInput {...confirmPasswordField} />
}
